var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{attrs:{"slot":"top-right"},slot:"top-right"},[_c('button',{staticClass:"closeButton",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.$modal.hide(_vm.modalName)}}},[_vm._v(" x ")])]),_c('div',[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }